import React from 'react'
import styles from './Utils.module.scss'



const CircleButton = ({onClick}:{onClick?:()=>void}) => {
    const click = () =>{
        onClick?.()
    }
    
    return (
            <div className={styles.circle_button} onClick={click}/>
    )
}
export default CircleButton
